import { formatDateString, getUTCHours, getUTCMinutes } from '../../utils';

const getStatementPaymentStatusInfo = (
  primaryStatus,
  secondaryStatus,
  paymentDate,
  isPaymentCarriedOver,
  invoiceInfo = null,
  paymentReferenceInfo = null,
  isPartner = false,
) => {
  let paymentStatusInfo;
  const invoice = invoiceInfo ? `${invoiceInfo}` : null;
  const paymentReference = paymentReferenceInfo ? `${paymentReferenceInfo}` : null;

  if (isPartner) {
    if (!primaryStatus || !secondaryStatus) {
      paymentStatusInfo = `Payment scheduled to send on ${formatDateString(paymentDate)}`;
    } else if (
      primaryStatus === 'Payment Sent' &&
      secondaryStatus === `Payment sent to beneficiary bank`
    ) {
      paymentStatusInfo = `Payment sent on ${formatDateString(paymentDate)} at ${getUTCHours(
        paymentDate,
      )}:${getUTCMinutes(paymentDate)} UTC`;
    } else {
      paymentStatusInfo = `Payment scheduled to send on ${formatDateString(paymentDate)}`;
    }
    return {
      paymentStatusInfo,
      invoice,
    };
  }

  if (primaryStatus === 'Not Available') {
    paymentStatusInfo = `Payment status not available`;
  } else if (isPaymentCarriedOver) {
    paymentStatusInfo = 'No Payment';
  } else {
    paymentStatusInfo = `${primaryStatus} - ${secondaryStatus} on ${formatDateString(
      paymentDate,
    )} at ${getUTCHours(paymentDate)}:${getUTCMinutes(paymentDate)} UTC`;
  }

  return {
    paymentStatusInfo,
    invoice,
    paymentReference,
  };
};

export default getStatementPaymentStatusInfo;
